module.exports = __webpack_public_path__ + "static/media/img2.924f37aa.jpg";